<template>
    <div>
        <!--刪除區塊-->
        <DeleteModal :deleteModal="deleteModal" @init="init()"></DeleteModal>
        <div class="List">
            <!--查詢功能列-->
            <b-row>
                <b-col>
                    <!--語系-->
                    <b-form-select
                    class="only-button-down"
                    :options="langurageOption"
                    v-model="search.langurage">
                    </b-form-select>
                </b-col>
                <b-col>
                    <!--關鍵字-->
                    <b-form-input
                        v-model="search.keywords"
                        placeholder="請輸入關鍵字"
                        maxlength="100">
                    </b-form-input>
                </b-col>
                <b-col>
                    <!--啟用狀態-->
                    <b-form-select
                        class="only-button-down"
                        :options="statusOptions"
                        v-model="search.status">
                    </b-form-select>
                </b-col>
                <b-col cols="2">
                    <!--清除按鈕-->
                    <b-button @click="cancelSearch" v-if="checkSearchIsEmpty()" title="清空查詢條件">
                        <b-icon icon="x-circle"></b-icon>
                    </b-button>
                    <!--查詢按鈕-->
                    <b-button @click="startSearch" title="開始查詢">
                        <b-icon icon="search"></b-icon>
                    </b-button>
                </b-col>
                <b-col cols="2">
                    <!--新增按鈕-->
                    <b-button
                    @click="gotoContent()" >
                        新增
                    </b-button>
                </b-col>
            </b-row>
            <b-container>
                <b-table-simple>
                    <b-thead>
                        <b-th>語系</b-th>
                        <b-th>標題</b-th>
                        <b-th>上下架日期</b-th>
                        <b-th>狀態</b-th>
                        <b-th>異動人員</b-th>
                        <b-th>異動日期</b-th>
                        <b-th>修改</b-th>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="item in DataList" :key="item.index">
                            <b-td>{{langurageOption.filter(x=> x.value == item.langurage)[0].text }}</b-td>
                            <b-td>{{ item.title }}</b-td>
                            <b-td>{{ dateFormat(item.startDate) +"~" + dateFormat(item.endDate) }}</b-td>
                            <b-td>{{  statusOptions.filter( x=> x.value == item.deployStatus)[0].text }}</b-td>
                            <b-td>{{  (item.modifierName)? item.modifierName : item.creatorName}}</b-td>
                            <b-td>{{(item.modifierName) ? dateFormat(item.modifyDate) : dateFormat(item.createDate)}}</b-td>
                            <!--功能按鈕-->
                            <b-td>
                                <b-button 
                                    class="mr-5"
                                    variant="info"
                                    @click="gotoContent(item.bannerId ,item.langurage)">
                                    編輯
                                </b-button>
                                <a href="javascript:void(0)"
                                    class="btn-delete"
                                    v-if="permission.isDelete"
                                    @click="functionDelete(item)">
                                   <img src="/images/backend/del_icon.png" alt="刪除icon" />
                                </a>
                            </b-td>   
                        </b-tr>     
                    </b-tbody>
                </b-table-simple>
            </b-container>
            <div class="page mt-2">
                <span class="pagination-total">共 {{Math.ceil(pagination.rows/pagination.perPage)}} 頁．{{pagination.rows}}筆資料</span>
                <b-pagination
                class="pagination light-theme simple-pagination"
                v-model="pagination.page"
                :total-rows="pagination.rows"
                :per-page="pagination.perPage"
                aria-controls="my-table">
                </b-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import DeleteModal from '../../Tool/deleteModal.vue';
export default{ 
    components:{
        DeleteModal,
    },
    data(){
        return{
            //類別編號
            PJ_ID:"",
            typeId: "",
            //文章編號
            id:"", 
            //語系
            lang:"",
            //樣式編號
            modal:"",
            //語系
            langurageOption:[
                {value:null,text:"全部語系"},
                {value:1,text:"中文版"},
                {value:2,text:"英文版"},
            ],
            //啟用選項
            statusOptions:[
                {value: null ,text:"全部發布狀態"},
                {value: 0 ,text:"停用"},
                {value: 1 ,text:"啟用"},
            ],
            //查詢資訊
            search:{langurage:null,status:null},
            //列表設定
            pagination: {
                perPage: 10,
                page: 1,
                rows: 5,
            },
            //列表資料
            DataList:[],
            //刪除模板
            deleteModal: {
                id: null,
                classes: null,
                parent: null,
                show: false,
                type: "Banner",
            },
        };
    },
    props:["value"],
    computed:{
    },
    mounted(){
        //初始化
        this.init();
    },
    watch:{
        "pagination.page"() {
        this.init();
      },
    },
    methods:{
        //初始化
        init(){
            //類別編號
            this.PJ_ID = this.value.PJID;
            //類別內部編號
            this.typeId = this.value.typeId;
            //文章編號
            this.id = this.value.id;
            //語系
            this.lang = this.value.lang?this.value.lang : 1;
            //樣式編號
            this.modal = this.value.modal;
            //是否為修改
            this.isUpdate = false;
            //取得畫面權限
            this.getPermission(this.PJ_ID);
            //開始查詢
            this.startSearch();
            
        },
        //開始查詢
        async startSearch(){
            try{
                //POST 參數
                let jsonReq = {
                    TYPE:"LIST",
                    VerifyCode:this.PJ_ID,
                    banner_SELECT: {
                        langurage: this.search.langurage,
                        keywords: this.search.keywords,
                        deployStatus: this.search.status,
                        pageIndex: this.pagination.page,
                        pageSize: this.pagination.perPage,
                    },
                };
                //Token
                let resToken = await this.userRequest.post("bicd/Token");
                jsonReq.Token = resToken.data;
                //執行API功能
                let res = await this.userRequest.post("bicd/banner",jsonReq);
                //讀取資料
                let json = JSON.parse(res.data);
                if(json.Status){
                    let jsonData = JSON.parse(json.Data);
                    this.DataList = jsonData.outData;
                    this.pagination.rows = jsonData.totalCount;
                }
            }catch(err){
                console.log("ErrFunction: startSearch/n "+err);
            }
        },
        //跳轉至編輯頁面
        gotoContent(gotoid=0,lang =1){
            this.$router.replace({
                path: this.$route.path,
                query:{
                    PJID:this.$route.query.PJID,
                    modal:3,
                    id:gotoid,
                    lang: lang
                }
            });
        },

        //清除查詢資訊
        cancelSearch(){
            //清空查詢條件
            this.search={langurage:null,status:null};
            //重新查詢事件
            this.startSearch();
        },
        gotoList(gotoid=0){
            this.$router.replace({
                path: this.$route.path,
                query:{
                    PJID:this.$route.query.PJID,
                    modal:2,
                }
            });
        },
        //刪除功能
        functionDelete(item) {
            this.deleteModal.show = true;
            this.deleteModal.id = item.bannerId;
            this.deleteModal.type = "Banner";
            this.deleteModal.langurage = item.langurage;
            this.deleteModal.VerifyCode = this.PJ_ID;
        },
    }
}
</script>